module.exports = __webpack_public_path__ + "media/BNP_Samodzielniak_23_B.8737d078.mp3";